import { SmtpFromMode } from "~/gql/graphqlBase.generated";

const maskSegment = (segment: string): string => {
	if (segment.length === 0) return "";
	if (segment.length === 1) return "*";
	if (segment.length === 2) return `${segment[0]}*`;
	return `${segment[0]}${"*".repeat(segment.length - 2)}${segment[segment.length - 1]}`;
};

export const maskSmtpUsername = (username: string): string => {
	const atIndex = username.indexOf("@");
	if (atIndex <= 0) return maskSegment(username);
	return `${maskSegment(username.slice(0, atIndex))}${username.slice(atIndex)}`;
};

export interface SmtpFromModeDetail {
	descriptionKey: string;
	label: string;
	value: SmtpFromMode;
}

export const SMTP_FROM_MODE_DETAILS: SmtpFromModeDetail[] = [
	{
		descriptionKey: "admin.email.smtp.fromMode.singleAccountDescription",
		label: "Single account",
		value: SmtpFromMode.SingleAccount
	},
	{
		descriptionKey: "admin.email.smtp.fromMode.definedListDescription",
		label: "Defined address list",
		value: SmtpFromMode.DefinedList
	},
	{
		descriptionKey: "admin.email.smtp.fromMode.anyWithListDescription",
		label: "Any address + defined list",
		value: SmtpFromMode.AnyWithList
	}
];

const FROM_MODE_LABELS: Record<SmtpFromMode, string> = Object.fromEntries(
	SMTP_FROM_MODE_DETAILS.map((detail) => [detail.value, detail.label])
) as Record<SmtpFromMode, string>;

export const smtpFromModeLabel = (mode: SmtpFromMode): string => FROM_MODE_LABELS[mode] ?? String(mode);

export interface SmtpAddressDisplay {
	displayName: string;
	email: string;
}

export const smtpAddressLabel = (address: SmtpAddressDisplay): string =>
	address.displayName ? `${address.displayName} <${address.email}>` : address.email;
